import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, GetRelatedProductCollectionApiV2Parameter, getRelatedProductsCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = { 
    productId: string,
    relationship: string,
    pageSize: number,
    expand: any,
} & HasOnSuccess<ProductModel[]>;

type Props = {
    apiResult: ProductCollectionModel;
    apiParameter: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
};

type HandlerType = CustomHandler<Parameter, Props>

export const SendDataToApi: HandlerType = async props => {
    const apiParameter = {
        productId: props.parameter.productId,
        relationship: props.parameter.relationship,
        pageSize: props.parameter.pageSize,
        expand: props.parameter.expand,
    }
    if ("relationship" in props.parameter) {
        props.apiResult = await getRelatedProductsCollectionV2(apiParameter);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult.products!);
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback];

const getRelatedProductOnCart = createHandlerChainRunner(chain, "getRelatedProductOnCart");
export default getRelatedProductOnCart;
